import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const haberSwiperEl = document.querySelector(".medya-haber-swiper");

  if (haberSwiperEl) {
    const container = haberSwiperEl.closest(".medya-haber-swiper-container");

    new Swiper(haberSwiperEl, {
      modules: [Navigation, Pagination],
      loop: false,
      spaceBetween: 30,
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        // Mobile-first approach
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }
});
